import React from 'react';
import { formatLabel, formatTemperature } from 'utils/helpers';

const FlammabilitySection = ({ chemicalDetails, isGas, isAboveTemperaturePoint }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 transition-all duration-300 hover:shadow-xl">
      <h2 className="text-2xl font-bold mb-6">
        <i className="fas fa-fire mr-2"></i>Flammability Information
      </h2>
      <div className="space-y-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

        {/* Explosive Concentration */}
        {chemicalDetails.flammability?.explosive_concentration?.LFL && chemicalDetails.flammability?.explosive_concentration?.UFL && (
          <div className="p-12 bg-gray-100 rounded-lg hover:bg-slate-300 transition-all">
            <div className="font-bold text-lg">{formatLabel('Flammable/Explosive Concentration')}</div>
            <div>
              {chemicalDetails.flammability.explosive_concentration.LFL} % - {chemicalDetails.flammability.explosive_concentration.UFL} %
            </div>
          </div>
        )}

        {/* Flash Point - Don't show for gases */}
        {!isGas && formatTemperature(chemicalDetails.storage?.flash_point) !== null && (
          <div className={`p-12 rounded-lg ${isAboveTemperaturePoint(chemicalDetails.storage.flash_point) ? 'text-red-600 bg-red-200' : 'text-green-600 bg-green-200'}`}>
            <div className="font-bold text-lg">{formatLabel('Flash Point')}</div>
            <div>
              <ul className="list-disc list-inside ml-4">
                <li>{formatTemperature(chemicalDetails.storage.flash_point)}</li>
              </ul>
            </div>

            {isAboveTemperaturePoint(chemicalDetails.storage.flash_point) && (
              <div className="warning-card p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                <div>
                  <i className="fas fa-exclamation-triangle mr-2"></i>
                  <strong>Alert</strong>
                </div>
                The current temperature of your selected location exceeds the flash point of this chemical. <strong>It may catch fire at any point. Please store in a cooler storage container.</strong>
              </div>
            )}
          </div>
        )}

        {/* No flammability info */}
        {!(chemicalDetails.flammability?.explosive_concentration?.LFL && chemicalDetails.flammability?.explosive_concentration?.UFL) && !(!isGas && formatTemperature(chemicalDetails.storage?.flash_point) !== null) && (
          <div className="col-span-1 md:col-span-2 lg:col-span-3">
            <div className="p-12 bg-gray-100 rounded-lg hover:bg-slate-300 transition-all">
              <div className="text-center">No flammability information available.</div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default FlammabilitySection;
